import useCreate from "@/hooks/use-create";
import useGetCustomerId from "@/hooks/use-get-customer-id";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { PaymentPayload } from "@/interfaces/talk2pay.iterfaces";
import t2payService from "@/services/t2pay.service";
import { RequestsProps } from "@/types/requests.types";

export type Props = {
  formData: PaymentPayload;
} & RequestsProps;

export type Return = {
  create: (props: Props) => Promise<PaymentPayload>;
} & UseLoadingReturn;

const useCreateTransfer = (): Return => {
  const customerId = useGetCustomerId();
  const _id = Number(customerId) || 0;

  const { isLoading, startLoading, endLoading, loadingIcon, create } = useCreate<PaymentPayload>({
    operation: (formData) => t2payService.createTransfer(formData, _id),
  });

  return { isLoading, startLoading, endLoading, loadingIcon, create };
};

export default useCreateTransfer;
